// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"5204cc88","320":"ece33e58","668":"5f1cfef7","715":"3fa3c96c"}[chunkId] + ".chunk.js";
};